import React, { useState } from "react";
import {
  Grid,
  Paper,
  Avatar,
  TextField,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import LockResetIcon from "@mui/icons-material/LockReset";
import { pink } from "@mui/material/colors";
import { useHistory } from "react-router";
import { resetPasswordEmailSending, validateOTP } from "../../services/Auth";
// import { sendResetLink } from "../services/Auth"; // You’ll need to implement this API call

const useStyles = makeStyles({
  paper: {
    padding: "20px",
    width: "60vh",
    margin: "20vh auto",
  },
  header: {
    marginTop: "0px",
  },
  headerTxt: {
    marginTop: "0px",
  },
});

function ForgotPassword() {
  const classes = useStyles();
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [otp, setOtp] = useState("");
  const [isValidToken, setIsValidToken] = useState(false);
  const [tokenValidating, setTokenValidating] = useState(false);

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
    setError("");
    setMessage("");
  };

  const handleChangeToken = (e) => {
    setOtp(e.target.value);
    setError("");
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Email is required");
      return;
    }

    try {
      const result = await resetPasswordEmailSending(email); // Backend API to trigger email
      if (result === "success") {
        setError("");
        setMessage("Password reset link sent. Check your inbox.");
        setTokenValidating(true);
      } else {
        setError(result || "Failed to send reset link.");
      }
    } catch (err) {
      setError("Something went wrong. Try again later.");
    }
  };

  const handleSubmitToken = async (e) => {
    e.preventDefault();
    if (!otp) {
      setError("Please enter one-time password");
      return;
    }

    try {
      const result = await validateOTP(email, otp);
      if (result === "success") {
        setError("");
        // Redirect to reset password page
        history.push("/resetpassword/" + email + "/" + otp);
      } else {
        setError(result || "The one-time password is invalid.");
      }
    } catch (err) {
      setError("Something went wrong. Try again later.");
    }
  };

  return (
    <Grid>
      <Paper elevation={10} className={classes.paper}>
        <Grid align="center" className={classes.header}>
          <h2>NORTEL (PVT) LTD</h2>
          <Avatar sx={{ bgcolor: pink[500] }}>
            <LockResetIcon />
          </Avatar>
          <h3 className={classes.headerTxt}>Forgot Password</h3>
        </Grid>

        {error && (
          <Typography
            align="left"
            variant="caption"
            style={{ color: "red", fontSize: 16, fontWeight: "bold" }}
          >
            {error}
          </Typography>
        )}
        {message && (
          <Typography
            align="left"
            variant="caption"
            style={{ color: "green", fontSize: 16, fontWeight: "bold" }}
          >
            {message}
          </Typography>
        )}

        <Stack direction="column" spacing={2}>
          {tokenValidating ? (
            <>
              <TextField
                label="OTP"
                type="text"
                fullWidth
                required
                value={otp}
                onChange={handleChangeToken}
                error={!!error}
                helperText={error}
              />
              <Button variant="contained" fullWidth onClick={handleSubmitToken}>
                Validate Token
              </Button>
            </>
          ) : (
            <>
              <TextField
                label="Email"
                type="email"
                fullWidth
                required
                value={email}
                onChange={handleChangeEmail}
                error={!!error}
                helperText={error}
              />
              <Button variant="contained" fullWidth onClick={handleSubmit}>
                Send Reset Link
              </Button>
            </>
          )}
        </Stack>

        <Typography align="center" sx={{ m: 2 }}>
          Remembered your password? <a href="/">Sign in</a>
        </Typography>
      </Paper>
    </Grid>
  );
}

export default ForgotPassword;
